// @flow
export default () => {};
